import { render, staticRenderFns } from "./PracticeLogoBadge.vue?vue&type=template&id=5987853e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5987853e')) {
      api.createRecord('5987853e', component.options)
    } else {
      api.reload('5987853e', component.options)
    }
    module.hot.accept("./PracticeLogoBadge.vue?vue&type=template&id=5987853e&", function () {
      api.rerender('5987853e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/PracticeLogoBadge.vue"
export default component.exports